import Furniture from './Furniture';
// import { NIGHT_TINT } from 'app/constants/AppConstants.js';

export default class Bench extends Furniture {
  constructor({ game, location, data }) {
    super({ game, location, data });

    this.version = 1;
  }

  createAsset() {
    this.asset = this.game.make.image(0, 0, this.data.key, 'bench');
    this.asset.anchor.set(0.5, 1);

    this.addChild(this.asset);
  }

  setLight(power) {
    this.setLight2(power);
  }

  updateTint(tween, value, tweenData) {
    super.updateTint(tween, value, tweenData);

    this.asset.tint = this.tintColor;
  }
}
